import { render, staticRenderFns } from "./CmgLeaderboardLocations.vue?vue&type=template&id=4544b51c&scoped=true&lang=pug"
import script from "./cmg-leaderboard-locations.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-locations.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardLocations.vue?vue&type=style&index=0&id=4544b51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544b51c",
  null
  
)

export default component.exports